import { render } from "./GeneralReportParameters.vue?vue&type=template&id=706bbf0a"
import script from "./GeneralReportParameters.vue?vue&type=script&lang=js"
export * from "./GeneralReportParameters.vue?vue&type=script&lang=js"

import "./GeneralReportParameters.vue?vue&type=style&index=0&id=706bbf0a&lang=css"

import exportComponent from "J:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__